/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'document-error': {
    width: 8,
    height: 10,
    viewBox: '0 0 8 10',
    data: '<g _stroke="#E25757" _fill="none" fill-rule="evenodd"><path pid="0" d="M1 1h4.013L7 3.032V9H1zM2.46 7h3.09"/></g>'
  }
})
